import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import api, { API } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { PawPrint } from "@phosphor-icons/react";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
    const nav = useNavigate();
    const { refresh } = useAuth();
    const processed = useRef(false);

    useEffect(() => {
        if (processed.current) return;
        processed.current = true;

        const hash = window.location.hash || "";
        const match = hash.match(/session_id=([^&]+)/);
        if (!match) { nav("/login", { replace: true }); return; }
        const session_id = decodeURIComponent(match[1]);

        (async () => {
            try {
                const { data } = await api.post("/auth/google/session", { session_id });
                if (data.session_token) {
                    localStorage.setItem("pawlink_token", data.session_token);
                }
                // Clear the hash and go to dashboard
                window.history.replaceState({}, "", "/home");
                await refresh();
                nav("/home", { replace: true });
            } catch {
                nav("/login?error=google", { replace: true });
            }
        })();
    }, [nav, refresh]);

    return (
        <div className="min-h-screen grid place-items-center bg-paw-bone dark:bg-[hsl(152,15%,8%)]">
            <div className="text-center">
                <span className="inline-grid place-items-center w-14 h-14 rounded-full bg-paw-forest text-white mb-4 animate-pulse">
                    <PawPrint size={28} weight="fill" />
                </span>
                <p className="text-paw-ink dark:text-paw-bone font-medium">Signing you in…</p>
            </div>
        </div>
    );
}
